var _defs, _defs2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgWarning = function SvgWarning(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    viewBox: "0 0 24 23",
    role: "presentation",
    "aria-hidden": true,
    ref: ref
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "warning_svg__a",
    d: "M9.2 2.2c1.6-2.9 4.1-2.9 5.7 0l8.3 15.4c1.6 2.9.2 5.3-3.2 5.3H4c-3.3 0-4.7-2.4-3.2-5.3zm0 0"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "warning_svg__b"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#warning_svg__a",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-4.8-5h33.6v32.9H-4.8z",
    style: {
      clipPath: "url(#warning_svg__b)",
      fill: "#ff0064"
    }
  }), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "warning_svg__c",
    d: "m12.7 15 .3-9.6h-2l.3 9.6zm-.7 4.1c.7 0 1.2-.5 1.2-1.2s-.5-1.2-1.2-1.2-1.2.5-1.2 1.2.5 1.2 1.2 1.2m0 0"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "warning_svg__d"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#warning_svg__c",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M5.8.4h12.4v23.7H5.8z",
    style: {
      clipPath: "url(#warning_svg__d)",
      fill: "#fff"
    }
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgWarning);
export { ForwardRef as Icon };
export default "img/warning.76eaf74.svg";